// extracted by mini-css-extract-plugin
module.exports = {"breakpoint-desktop":"(min-width: 992px)","list":"VenueCardList-module--list--f98e13"};